import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Button, Table, Select, Input, Tooltip, Modal } from 'antd'

import { req_page_bulletinBoard_public } from '../../api'

import { usrRole } from '../../utils/dataUtil'
import { ORG_CODE, SYS_CODE, API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { formateDate } from '../../utils/dateUtil'

import DetailsBulletinboardModal from './details-bulletinboard-modal'


class SearchBulletinBoard extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: 'INTERVAL', // INTERVAL/ERROR/YET/OVER

        domnloadFile: '',
        isShowModal: false,
    }

    UNSAFE_componentWillMount() {
        window.removeEventListener("resize", this.resize.bind(this));
        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.api_page_items(1)
    }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }


    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true, items: [] })
        const result = await req_page_bulletinBoard_public(ORG_CODE, SYS_CODE, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '主旨',
                dataIndex: 'msgTitle',
                width: 100,
                render: (field) => {
                    return (
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                    )
                },
            },
            {
                title: '發佈者',
                dataIndex: 'msgAuthorName',
                width: 40,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '發佈時間',
                width: 40,
                responsive: ['md'],
                render: (item) => {
                    const { publishDateTime } = item
                    return (
                        <span>
                            {formateDate(publishDateTime)}
                        </span>
                    )
                }
            },
            {
                title: '',
                width: 30,
                fixed: 'right',
                render: (item) => {
                    const { deviceWidth } = this.state
                    const { attacheFileUrl } = item
                    const downloadUrl = API_BASE + attacheFileUrl
                    return (
                        <span>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_show_ui_modal('view', item)}><i className="fas fa-stream"></i> {deviceWidth > 600 ? (<span style={{ marginLeft: '4px' }}>詳情</span>) : ''}</button>
                            {attacheFileUrl === 'NA' || attacheFileUrl === '' ? '' : (<><a href={downloadUrl} download="檔案下載" className='btn btn-outline-dark btn-sm'><i className="fas fa-cloud-download-alt"></i>{deviceWidth > 600 ? (<span style={{ marginLeft: '4px' }}>下載</span>) : ''}</a></>)}
                        </span>
                    )
                }
            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                this.setState({ isShowModal: true, item })
                break;
            case 'edit':
                this.setState({ isEditModal: true, item })
                break;
            case 'download':
                this.setState({ isDownloadModal: true, item })
                break;
            default:
        }
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, items, pagination, searchField, searchValue, isShowModal, item } = this.state
        const title = (
            <>
                <span>公告：</span>
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='NONE'>搜索條件</Select.Option>
                    <Select.Option value='msgTitle'>主旨</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 100, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isShowModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isShowModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <DetailsBulletinboardModal bulletinboard={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(SearchBulletinBoard)